import React, { useState } from 'react';
import {
  useEntitySelectionTestQuery,
  TieredEntitySelectionInput,
} from '../../../../types/generated-types';
import { Box, Button } from '@mui/material';
import { JsonEditor, githubDarkTheme } from 'json-edit-react';

export const QueryTester = ({
  value,
}: {
  value: TieredEntitySelectionInput;
}) => {
  const [shouldRunTest, setShouldRunTest] = useState(false);

  const { data: testData, loading: testLoading } = useEntitySelectionTestQuery({
    variables: {
      selection: value,
    },
    skip: !shouldRunTest,
  });

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Button
        variant="contained"
        onClick={() => {
          if (shouldRunTest) {
            setShouldRunTest(false);
            setTimeout(() => setShouldRunTest(true), 100);
          } else {
            setShouldRunTest(true);
          }
        }}
        disabled={testLoading}
      >
        {!!testData
          ? 'Re-run test'
          : testLoading
            ? 'Running Test...'
            : 'Run Test'}
      </Button>
      {testData ? (
        <JsonEditor
          data={
            testData.executeTieredEntitySelection[0]?.data ?? 'No Data Returned'
          }
          theme={githubDarkTheme}
          restrictAdd={true}
          restrictDelete={true}
          restrictDrag={true}
          restrictEdit={true}
          restrictTypeSelection={true}
        />
      ) : (
        <JsonEditor
          data={value}
          theme={githubDarkTheme}
          restrictAdd={true}
          restrictDelete={true}
          restrictDrag={true}
          restrictEdit={true}
          restrictTypeSelection={true}
        />
      )}
    </Box>
  );
};
